export function formatKokoroVoiceName(rawName) {
    const name = String(rawName ?? '');
    const nameWithoutPrefix = name.replace(/^[a-z]{2}_/i, '');
    const displayName = nameWithoutPrefix
        .split(/[_-]/)
        .filter(Boolean)
        .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
        .join(' ');

    return displayName || name;
}

export function formatVoiceDisplayName(rawName, modelName = '') {
    const kokoroModels = ['Kokoro v1.0', 'Kokoro_v1.0', 'Kokoro v1_0', 'Kokoro_v1'];
    if (kokoroModels.includes(modelName)) {
        return formatKokoroVoiceName(rawName);
    }
    return rawName ?? '';
}
